import { render, staticRenderFns } from "./AdminData.vue?vue&type=template&id=452769b5&scoped=true"
import script from "./AdminData.vue?vue&type=script&lang=js"
export * from "./AdminData.vue?vue&type=script&lang=js"
import style0 from "./AdminData.vue?vue&type=style&index=0&id=452769b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452769b5",
  null
  
)

export default component.exports